<template>
    <div class="main-body">
        <div class="header">咨询记录</div>
        <div class="out">

            <div class="search2">

              <el-button size="mini" type="primary"  @click.native="toggleModalAdd">添加</el-button>

              <div style="float: right;">

                <el-select v-model="status" size="mini" clearable placeholder="请选择状态" style="width:120px;margin-right:10px">
                  <el-option
                      v-for="item in statusValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>

                <el-date-picker style="margin-right: 10px;width:250px;" title="起止时间" size="mini"
                                v-model="startEndTime"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间">
                </el-date-picker>

                <el-button type="primary" size="mini" icon="el-icon-search" @click="getList(true)">搜索</el-button>

              </div>

              <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">

                <el-table-column prop="userName" label="用户姓名" ></el-table-column>
                <el-table-column prop="userPhone" label="用户手机号" ></el-table-column>
                <el-table-column prop="questionTime" :formatter="timefilter"  label="咨询时间"></el-table-column>
                <el-table-column prop="staffName" label="职工姓名" ></el-table-column>
                <el-table-column prop="staffPhone" label="职工手机号" ></el-table-column>
                <el-table-column prop="replyTime" :formatter="timefilter"  label="答复时间"></el-table-column>
                 <el-table-column prop="status" :formatter="statusFormatter"  label="状态" min-width="80"></el-table-column>

              <el-table-column  label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status==1" type="primary" size="mini" @click="handle(scope.row)">答复</el-button>
                        <el-button v-if="scope.row.status==2" type="success" size="mini" @click="look(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>
        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="showModalAdd=false"  v-on:getList="getList"></Add>
        <Reply ref="myReply" v-show="showModalReply" v-on:closeReply="showModalReply=false"  v-on:getList="getList"></Reply>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    import Add from "./Add"
    import Reply from "./Reply"

    export default {
        name: "Role",
        data(){
            return{
                tableLoading:false,
                showModalAdd:false,
                showModalReply:false,

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,


              statusValue:[{value:-1,label:'全部状态'},{value:1,label:'未答复'},{value:2,label:'已答复'}],
              status:-1,

              startEndTime:[],

            }
        },
        created(){
            this.init();
            this.th = this.$store.state.tableHeight;
        },
        components:{
            Add,Reply
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){


              const end = new Date();
              const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
              this.startEndTime = [start, end];

              this.getList(false);

            },
            toggleModalAdd:function(){
                this.$refs.myAdd.init();
                this.showModalAdd = !this.showModalAdd;
            },
            statusFormatter(row){
                if(row.status==1){
                    return "未答复"
                }else{
                    return "已答复"
                }
            },
            dataChange(val){
                this.searchForm.startTime=val[0]
                this.searchForm.endTime=val[1]
            },

            getZoneValue(val){
                this.zoneCode=val
            },
            //日期格式
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            handle:function(row){
                this.$refs.myReply.init(row,false);
                this.showModalReply = !this.showModalReply;
            },
            look:function(row){
                this.$refs.myReply.init(row,true);
                this.showModalReply = !this.showModalReply;
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1

                var _this=this
                this.tableLoading=true
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,
                  status:this.status,

                  startTime: timefilters(this.startEndTime[0]),
                  endTime: timefilters(this.startEndTime[1]),

                }
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"ConsultRecord/PageAdm",
                    data: data
                }).then( (response)=> {
                    _this.tableLoading=false
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },
            statusTitle(row, column, cellValue){
                 return this.allStatus(cellValue,['建议','投诉']);
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            }



        }
    }
</script>

<style scoped>

</style>
